import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { TryCatchMaterialExtensionModule } from "@dodo/material-extension/material-extension.module";
import { MaterialModule } from "../../_libs/material-module/material.module";
import { TryCatchMaterialFormsModule } from "@dodo/material-forms";
//import { KioskHomeComponent } from "./kiosk-home/kiosk-home.component";
//import { KioskAuthGuard } from "./kiosk-auth.guard";
import { BoboPaymentComponent } from "./bobo-payment/bobo-payment.component";
import { BoboPaymentDetailsComponent } from "./bobo-payment-details/bobo-payment-details.component";
import { BoboThankyouComponent} from "./bobo-thankyou/bobo-thankyou.component";
import { AppCoreModule } from "../_core/core.module";
import { DodoMatComponentsModule } from "../../_libs/dodo-mat-components/dodo-mat-components.module";
import { AuthGuard } from "@auth0/auth0-angular";

const routes: Routes = [
	{
		path: "",
		component: BoboPaymentComponent,
		pathMatch: "full",
	},
	{
		path: "payment-details",
		component: BoboPaymentDetailsComponent
	},
	{
		path: "thankyou",
		component: BoboThankyouComponent
	}
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		AppCoreModule,
		ReactiveFormsModule,
		FormsModule,
		MaterialModule,
		DodoMatComponentsModule,
		TryCatchMaterialExtensionModule,
		TryCatchMaterialFormsModule
	],
	declarations: [
	BoboPaymentComponent,
	BoboPaymentDetailsComponent,
	BoboThankyouComponent
	]
})
export class BoboModule {}
